import { useStaticQuery, Link, graphql } from "gatsby"
import React from "react"
import SocialMediaLinks from "@one-builder/gatsby-theme-ob-master/src/components/social-links"
import NavigationItem from "@one-builder/gatsby-theme-ob-master/src/components/layout/navigation/navigation_item"
import LogoSecondary from "../logoSecondary"
import { FaPhone, FaRegEnvelope, FaMapMarkerAlt } from "react-icons/fa"
import styles from "@one-builder/gatsby-theme-ob-master/src/styles/global.module.scss"
import { GoTriangleRight } from "react-icons/go"
const Footer = ({ metadata }) => {
  // Get footer services and navigation
  const data = useStaticQuery(graphql`
    query {
      allMarkdownRemark(
        filter: {
          frontmatter: { is_active: { eq: true } }
          fileAbsolutePath: { regex: "/(/service_categories/)/" }
        }
        sort: { fields: frontmatter___name }
        limit: 7
      ) {
        edges {
          node {
            id
            frontmatter {
              name
            }
            fields {
              slug
            }
          }
        }
      }
      navigationYaml {
        navigation {
          nav_item {
            page_id
          }
        }
      }
      all_pages: allMarkdownRemark {
        edges {
          node {
            frontmatter {
              page_id
              title
            }
          }
        }
      }
    }
  `)
  return (
    <>
      <footer>
        <div className={styles.container}>
          <div className={styles.footer_sub}>
            <div  style={{
              width: `120px`
            }} className={styles.footer_logo}>
              <Link to="/"><LogoSecondary /></Link>
            </div>
            <div className={styles.contactbox}>
              <span>
                {" "}
                <FaPhone />
                <a
                  href={`tel:${metadata.CompanyPhone}`}
                  title={metadata.CompanyPhone}
                >
                  {metadata.CompanyPhone}
                </a>
              </span>
              <span>
                {" "}
                <FaRegEnvelope />
                <a
                  href={`mailto:${metadata.CompanyEmail}`}
                  title={metadata.CompanyEmail}
                >
                  {metadata.CompanyEmail}
                </a>
              </span>
              <span>
                {" "}
                <FaMapMarkerAlt />
                <div title={metadata.CompanyAddress.city}>
                  {metadata.CompanyAddress.street}{" "}
                  {metadata.CompanyAddress.city}
                  {", "}
                  {metadata.CompanyAddress.state}
                </div>
              </span>
            </div>
          </div>
          <div className={styles.footer_sub}>
          <div className={styles.footerCta}>
            <div className={styles.hpBtns}>
                <Link href="/contact" title="Contact Us">
                  Contact Us <GoTriangleRight />
                </Link>
            </div>
            <SocialMediaLinks />
          </div>
          </div>
        </div>
      </footer>
      <div className={styles.footerBar}>
        <div className={styles.container}>
          <div>
            © {new Date().getFullYear()}
            {` `}
            {metadata.CompanyName}
          </div>
          <div className={styles.ppLink}>
            <Link to="/privacy-policy/">Privacy Policy</Link>
            <Link to="/terms-and-conditions/">Terms of Use</Link>
            <a href="/sitemap.xml">Sitemap</a>
          </div>
        </div>
      </div>
    </>
  )
}
export default Footer